import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=20e5cb59&scoped=true"
import script from "./index-old.vue?vue&type=script&lang=js"
export * from "./index-old.vue?vue&type=script&lang=js"
import style0 from "./index-old.vue?vue&type=style&index=0&id=20e5cb59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5cb59",
  null
  
)

export default component.exports